
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
@Component({
  components: {}
})
export default class PiCashTemplateTr1 extends Vue {
  @Prop({
    default: () => {
      return {};
    }
  })
  private tableData!: objAny;
}
